module.exports = __webpack_public_path__ + "assets/c5edf7d874498d40f3376624b284d1d6.mp3";